(() => {
 'use strict';
 const mount = root => {
  if (root.dataset.bannerMotion) return;
  root.dataset.bannerMotion = 'ready';
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const pointer = matchMedia('(hover:hover) and (pointer:fine) and (min-width:900px)');
  const pause = root.querySelector('[data-re-banner-pause]');
  const abort = new AbortController(), signal = abort.signal;
  let visible = false, frame = 0, x = 0, y = 0, active = null, picture = null;
  const clamp = (v, a, b) => Math.min(b, Math.max(a, v));
  const eligible = () => !reduced.matches && !document.hidden && pause?.getAttribute('aria-pressed') !== 'true';
  const clear = image => ['x','y','rx','ry','scale'].forEach(k => image?.style.removeProperty('--banner-' + k));
  const update = () => {
   frame = 0;
   if (!visible || !eligible() || !picture) return;
   const rect = root.getBoundingClientRect();
   // Two or three small wheel movements produce one bounded, reversible sweep.
   // The page continues to scroll naturally; neither scroll nor touch is captured.
   const progress = clamp(-rect.top / Math.min(520, rect.height * .72), 0, 1);
   const smooth = progress * progress * (3 - 2 * progress);
   const desktop = pointer.matches;
   const values = {
    x: ((desktop ? x * 5 : 0) + smooth * (desktop ? -5 : -2)).toFixed(2) + 'px',
    y: ((desktop ? y * 3 : 0) + smooth * (desktop ? 10 : 5)).toFixed(2) + 'px',
    rx: ((desktop ? -y * .7 : 0) + smooth * -.55).toFixed(3) + 'deg',
    ry: ((desktop ? x * 1.5 : 0) + smooth * (desktop ? 1.8 : .9)).toFixed(3) + 'deg',
    scale: (1.035 + smooth * .008).toFixed(4)
   };
   Object.entries(values).forEach(([k,v]) => picture.style.setProperty('--banner-' + k,v));
  };
  const schedule = () => {if (visible && eligible() && picture && !frame) frame = requestAnimationFrame(update);};
  const sync = () => {
   const next = root.querySelector('[data-re-slide].is-active');
   if (next !== active) {clear(picture);active = next;picture = active?.querySelector('.re-campaign-artwork picture');x = y = 0;}
   root.dataset.bannerMoving = String(visible && eligible());
   if (!eligible() || !visible) {cancelAnimationFrame(frame);frame = 0;}
   if (!eligible()) clear(picture);
   schedule();
  };
  const intersection = new IntersectionObserver(entries => {visible = entries[0].isIntersecting;sync();},{threshold:0});
  const changes = new MutationObserver(sync);
  intersection.observe(root);
  changes.observe(root,{subtree:true,attributes:true,attributeFilter:['class','aria-pressed']});
  root.addEventListener('pointermove',event => {
   if (!eligible() || !pointer.matches || event.pointerType !== 'mouse' || !picture) return;
   const rect = active.querySelector('.re-campaign-artwork').getBoundingClientRect();
   x = clamp((event.clientX - rect.left) / rect.width * 2 - 1,-1,1);
   y = clamp((event.clientY - rect.top) / rect.height * 2 - 1,-1,1);
   schedule();
  },{passive:true,signal});
  const neutral = () => {x = y = 0;schedule();};
  root.addEventListener('pointerleave',neutral,{passive:true,signal});
  root.addEventListener('pointercancel',neutral,{passive:true,signal});
  root.addEventListener('focusin',neutral,{signal});
  window.addEventListener('scroll',schedule,{passive:true,signal});
  window.addEventListener('resize',sync,{passive:true,signal});
  window.addEventListener('pageshow',sync,{signal});
  window.addEventListener('pagehide',() => {cancelAnimationFrame(frame);frame = 0;},{signal});
  document.addEventListener('visibilitychange',sync,{signal});
  reduced.addEventListener('change',sync,{signal});
  pointer.addEventListener('change',sync,{signal});
  document.addEventListener('shopify:section:unload',event => {
   if (!event.target.contains(root)) return;
   intersection.disconnect();changes.disconnect();abort.abort();cancelAnimationFrame(frame);
  },{signal});
  sync();
 };
 document.querySelectorAll('[data-re-banner]').forEach(mount);
 document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-re-banner]').forEach(mount));
})();
